<script setup lang="ts">
import { nextTick, ref, watch } from 'vue'
import { useScreenSize } from '@/composables/helpers/screen-size'
import ArrowDown from '@/components/icons/ArrowDown.vue'

defineProps<{
	question: string
	answer: string
}>()

const emit = defineEmits<{
	(e: 'expand', isExpanded: boolean): void
}>()

const isExpanded = ref(false)
const slotHeight = ref(isExpanded.value ? 'auto' : 0)
const slotRef = ref<HTMLElement | null>(null)
const toggle = () => {
  isExpanded.value = !isExpanded.value
  emit('expand', isExpanded.value)
  nextTick(setSlotHeight)
}

const setSlotHeight = () => {
  if (!slotRef.value) return 0
  slotHeight.value = slotRef.value.offsetHeight
}

watch(slotRef, (slotRef) => {
  if (slotRef) {
    nextTick(setSlotHeight)
  }
}, { immediate: true })

const { width } = useScreenSize()
watch(width, () => {
  nextTick(setSlotHeight)
})
</script>

<template>
  <div
    class="overflow-hidden bg-dark-bottom-layer rounded-xl px-3"
  >
    <div
      class="w-full flex items-start cursor-pointer gap-x-3 py-[14px]"
      @click="toggle"
    >
      <div
        class="flex-1 text-base font-semibold -tracking-[0.32px]"
      >
        {{ question }}
      </div>
      <ArrowDown
        class="size-6 min-w-[24px] transition-transform duration-200 ease-linear"
        :class="{'rotate-180': isExpanded}"
      />
    </div>
    <div
      :style="isExpanded ? `height: ${slotHeight}px` : 'height: 0px'"
      class="w-full transition-[height,margin] duration-200 ease-linear"
      :class="isExpanded ? '-mt-2.5' : 'mt-0'"
    >
      <div
        ref="slotRef"
      >
        <div
          class="w-full flex items-start cursor-pointer gap-x-3 pb-[14px]"
        >
          <div
            class="flex-1 text-sm font-medium text-white/60"
            v-html="answer"
          />
          <div class="size-6 min-w-[24px]" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>